<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->
<div class="lf-box" [class.grey-bg]="greyBackground">
  <div class="top d-flex justify-content-between align-items-center">
    <ng-container *ngIf="sectionTitle">
      <ng-container *ngIf="tooltipText; else titleOnly">
        <lfx-hover-trigger
          theme="dark"
          [openDelay]="200"
          [closeDelay]="100"
        >
          <div class="lf-box-title">{{ sectionTitle }}</div>
          <div slot="popover-content" class="header-tooltip-content" [innerHTML]="tooltipText">
          </div>
        </lfx-hover-trigger>
      </ng-container>
      <ng-template #titleOnly>
        <div class="lf-box-title">{{ sectionTitle }}</div>
      </ng-template>
    </ng-container>
    <ng-content select="[topRight]"></ng-content>
  </div>
  <p *ngIf="subtitle" class="lf-box-subtitle">
    {{ subtitle }}
  </p>
  <ng-container *ngTemplateOutlet="content"></ng-container>
  <ngx-spinner
    *ngIf="isLoading"
    type="ball-clip-rotate"
    [fullScreen]="false"
    [name]="getSpinnerName()"
    color="rgba(0,0,0,0.5)"
    bdColor="rgba(255,255,255,0.5)"
    size="default"
  ></ngx-spinner>
</div>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
